import { useMemo } from "react";
import PropTypes from "prop-types";

const RATING_MULTIPLIER = 2;
const MAX_BARS = 10;
const POOR_THRESHOLD = 2;
const FAIR_THRESHOLD = 4;
const AVERAGE_THRESHOLD = 6;
const GOOD_THRESHOLD = 8;

const RATING_DEFAULT = "default";
const RATING_POOR = "poor";
const RATING_FAIR = "fair";
const RATING_AVERAGE = "average";
const RATING_GOOD = "good";
const RATING_EXCELLENT = "excellent";

const COLOR_CLASSES = {
	[RATING_DEFAULT]: "tw-bg-[#e2e4e4]",
	[RATING_POOR]: "tw-bg-[#ff343a]",
	[RATING_FAIR]: "tw-bg-[#ffc334]",
	[RATING_AVERAGE]: "tw-bg-[#ddd14d]",
	[RATING_GOOD]: "tw-bg-[#a0c15a]",
	[RATING_EXCELLENT]: "tw-bg-[#27b020]",
};

const getRatingColor = (rounded) => {
	if (rounded <= POOR_THRESHOLD) return RATING_POOR;
	if (rounded <= FAIR_THRESHOLD) return RATING_FAIR;
	if (rounded <= AVERAGE_THRESHOLD) return RATING_AVERAGE;
	if (rounded <= GOOD_THRESHOLD) return RATING_GOOD;

	return RATING_EXCELLENT;
};

export const BaseColorBarRating = ({ rating, classNames }) => {
	const bars = useMemo(() => {
		const rounded = Math.floor(rating * RATING_MULTIPLIER);
		const filledBars = Math.min(rounded, MAX_BARS);
		const emptyBars = MAX_BARS - filledBars;
		const ratingColor = getRatingColor(rounded);

		return [
			...Array(filledBars).fill(ratingColor),
			...Array(emptyBars).fill(RATING_DEFAULT),
		];
	}, [rating]);

	const barClassName = useMemo(
		() => (classNames?.bar ? ` ${classNames.bar}` : ""),
		[classNames?.bar],
	);

	return (
		<div className={classNames?.wrapper}>
			{bars.map((colorType, idx) => (
				<span
					key={idx}
					className={`${COLOR_CLASSES[colorType]}${barClassName}`}
				/>
			))}
		</div>
	);
};

BaseColorBarRating.propTypes = {
	rating: PropTypes.number,
	classNames: PropTypes.object,
};
